import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import 'draft-js/dist/Draft.css';

import { apiList } from '../../../api/callAPI';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';

import { CustomFormLabel } from '../../customComponent';

import useUser from '../../../hook/useUser';
import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import {
  HelpOutlineIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
} from '../../../constants/images';
import { Button } from '@mui/material';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const TaboolaCampaignData = ({ selectedAdAccounts, campaignList, selectedCampaign, setSelectedCampaign, handleCampaignData, fetchData }) => {
  const { locale, setLocale, entryPath } = useGlobalStatus();
  const [allCampaignChecked, setAllCampaignChecked] = useState(false);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  //選擇全部廣告活動
  useEffect(() => {
    if (campaignList.length !== 0 && selectedCampaign.length === campaignList.length) {
      setAllCampaignChecked(true);
    } else {
      setAllCampaignChecked(false);
    }
  }, [selectedCampaign])

  //選擇全部廣告活動
  const changeAllCampaign = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      setAllCampaignChecked(true);
      setSelectedCampaign(campaignList);
    } else {
      setAllCampaignChecked(false);
      setSelectedCampaign([]);
    }
  }

  return (
    <Box mb={5}>
      <Box
        mt={2}
        sx={{ width: '100%' }}
      >
        <Stack variant='between-center'>
          <CustomFormLabel>
            廣告活動
            <Tooltip title="選擇廣告帳號後可匯入廣告活動">
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>
          {
            selectedAdAccounts.length > 0 && entryPath.includes('create') &&
            <Button
              variant='text-taboola'
              onClick={() => fetchData(apiList.taboolaGetCampaign, 'campaignList', (resData) => {
                handleCampaignData(resData, 'click');
              })}
              disabled={campaignList.length > 0 ? true : false}
            >
              匯入廣告活動
            </Button>
          }
          {
            selectedAdAccounts.length > 0 && entryPath.includes('edit') &&
            <Button
              variant='text-taboola'
              onClick={() => fetchData(apiList.taboolaGetCampaign, 'campaignList', (resData) => {
                handleCampaignData(resData, 'click');
              })}
              disabled={campaignList.length > 0 ? true : false}
            >
              匯入廣告活動
            </Button>
          }
        </Stack>

        <Autocomplete
          multiple
          size="small"
          id="selectCampaign"
          options={campaignList}
          groupBy={(option) => option.cidname}
          disableCloseOnSelect={campaignList.length > 1 ? true : false}
          disableClearable={true}
          noOptionsText={"找不到廣告活動"}
          value={selectedCampaign}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                color={colorMedia}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color={colorMedia}
              placeholder={"若未勾選，系統預設匯出所有廣告活動"}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedCampaign(newValue);
          }}
          ChipProps={{
            deleteIcon: <HighlightOffOutlinedIcon />
          }}
          popupIcon={<KeyboardArrowDownOutlinedIcon />}
        />
        {
          <CustomFormLabel
            sx={{
              display: 'inline-block',
              mt: '2px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setSelectedCampaign(campaignList)
            }}
          >
            <Checkbox
              size="small"
              name="allCampaign"
              color={colorMedia}
              checked={allCampaignChecked}
              onChange={changeAllCampaign}
              disabled={campaignList.length > 0 ? false : true}
            />
            所有廣告活動
          </CustomFormLabel>
        }
      </Box>
    </Box>
  )
}

export default TaboolaCampaignData;